import { ICellRendererParams, ICellEditorParams } from "ag-grid-community";
import React from "react";
import { SaleStatusComponent } from "containers/UserDashboard/Cards/StatusSelect";

export function SaleStatusRenderer(params: ICellRendererParams) {
  if (!params.data || !params.data.livestockSale) {
    return params.getValue() || "";
  }

  const livesstockSaleId = params.data.livestockSale.id;

  return <SaleStatusComponent saleId={livesstockSaleId} forGrid />;
}

export function SaleStatusEditor(params: ICellEditorParams) {
  if (!params.data || !params.data.livestockSale) {
    return null;
  }

  const livesstockSaleId = params.data.livestockSale.id;

  const onEditComplete = () => {
    params.api.stopEditing();
  };

  return (
    <SaleStatusComponent
      saleId={livesstockSaleId}
      forGrid
      onEditComplete={onEditComplete}
    />
  );
}
